export default "__VITE_ASSET__ca0df887__"